@if (universalService.downloadInProgress) {
  <div>
    <div id="downloadComponent" class="progress_container" style="display: block;">
      <div class="progress_container_header pogressBarHeaderCont">
        <p>
          <span>
            &nbsp; Downloading item(s)
          </span>
        </p>
        <div class="progress_btn_container">
          <span class="NeueDropdown_Inactive hidden upload_generic_style" (click)="$event.stopPropagation();$event.preventDefault();minimizeDownloadProgressBar()" id="collapse_btn_dwn" ></span>
          <span class="NeueDropdown_Active upload_generic_style" (click)="$event.stopPropagation();$event.preventDefault();maxmizeDownloadProgressBar()" id="expand_btn_dwn" ></span>
          <span class="NeueFile_Cancel upload_generic_style" id='closeProgressDwn' (click)="closeDownload()" ></span>
        </div>
      </div>
      @if (downloadModalMaximised) {
        <div id="dwn_list">
          @for (item of universalService.downloadQueue; track item) {
            <div class="progress_container_header borderUploadBtm" >
              <div style="float: left;" class="uploadCncelBtn upldTimeContainer" >
                <span style="color: black;padding: 0 8px;float: left;">{{item.statusText}}</span>
              </div>
              <div class="uploadCncelBtn">
                @if (item.statusText.includes('Compressing')) {
                  <span class="progressOptText pointer" (click)="cancelDownload(item)">
                    Cancel
                  </span>
                }
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>
}